import PropTypes from 'prop-types';
import OnboardingContainer from '$src/components/OnboardingContainer';
import useLocationContext from '$src/hooks/useLocationContext';
import aboutImage from '$src/assets/img/onboardingAbout.png';
import { handleBackToRingDashboard } from '$src/utils/handleBack';
import useStores from '$src/hooks/useStores';
import { CustomIcon } from '$src/components/CustomIcon';
import { redirectToOnboardingEventsAndPrivacy, redirectToOnboardingSetupComplete } from '$src/utils/redirect';
import { StarkIcon } from '@ring-icons';

import './HowVSGWorks.less';

function Line({ text }) {
  return (
    <div className="how-vsg-works-line">
      <CustomIcon type="regular" name="check.svg" className="how-vsg-works-line-icon" />
      <p className="how-vsg-works-line-text">{text}</p>
    </div>
  );
}

Line.propTypes = {
  text: PropTypes.string.isRequired,
};

function HowVSGWorks() {
  const locationId = useLocationContext();
  const {
    sessionStore: { isMobile },
  } = useStores();

  return (
    <OnboardingContainer
      headerTitle="How Virtual Security Guard Works"
      icon={StarkIcon}
      title="What to expect from Virtual Security Guard."
      subtitle="Here’s what you and your emergency contacts can expect when the service is active, depending on the type of event and your alert preferences."
      primaryText="Continue"
      secondaryText="Go To Ring Dashboard"
      image={aboutImage}
      handleClose={() => handleBackToRingDashboard(isMobile)}
      handleBack={() => redirectToOnboardingSetupComplete(locationId)}
      primaryActionHandler={() => redirectToOnboardingEventsAndPrivacy(locationId)}
      secondaryActionHandler={() => handleBackToRingDashboard(isMobile)}
    >
      <Line text="When a person is detected, Virtual Guards will look at your enrolled camera’s Live View and observe the activity." />
      <Line text="Guards monitor motion events on your cameras that are triggered by a person. We prioritize activity that needs your attention so you will not receive a text message about certain events, such as passersby, animals, or vehicles." />
      <Line text="Guards will observe service workers and deliveries and notify you about the activity via text message." />
      <Line text="Guards will use your camera’s speaker to notify any person who isn’t clearly providing a service that your property is being monitored. You will receive a text message about the activity if the Guard determines no further action is needed." />
      <Line text="If the Guard determines an incident requires police, fire or medical dispatch, they will use your camera’s speaker to engage and/or activate your camera’s siren if it has one, then request emergency services. You and your emergency contacts will receive a phone call notifying you of the situation." />
    </OnboardingContainer>
  );
}

export default HowVSGWorks;
